export default __webpack_public_path__ + "static/media/adoptzi_green_logo.489767a2.svg";